import { OnboardingPhase } from "@forgepoint/shared";

/** A phase's computed bar placement and status on the gantt timeline. */
export interface GanttBar {
  phase: OnboardingPhase;
  barStart: Date;
  barEnd: Date;
  status: "done" | "active" | "upcoming";
}

/** Bar fill class per gantt status, shared by the bars and the legend. */
export const BAR_STATUS_CLASS: Record<GanttBar["status"], string> = {
  done: "bg-success/80",
  active: "bg-primary",
  upcoming: "bg-muted-foreground/25",
};
